import * as Effect from "effect/Effect";
import { AtomRegistry } from "effect/unstable/reactivity";
import { appAtomRegistry } from "../rpc/atomRegistry";
import { complianceOverviewGovernanceAtoms } from "./governance";
import { complianceOverviewPolicyAtoms } from "./policies";

/** Starts the page's existing tenant-scoped reads; their idle TTL bounds retention. */
export function prefetchComplianceOverview(
  organizationId: string | null,
  registry: AtomRegistry.AtomRegistry = appAtomRegistry,
): void {
  if (!organizationId) return;
  for (const atom of [
    ...complianceOverviewGovernanceAtoms(organizationId),
    ...complianceOverviewPolicyAtoms(organizationId),
  ]) {
    // Stay subscribed while async dependencies and the request resolve. A plain
    // get can leave a speculative atom dirty with nobody to restart its read.
    // Exit captures failures; normal page reads still expose their error state.
    void Effect.runPromiseExit(AtomRegistry.getResult(registry, atom, { suspendOnWaiting: true }));
  }
}
